import React from 'react'
import PropTypes from 'prop-types'
import { useTheme } from 'styled-components'
import { QuotesCloudSvg } from 'assets/svg'
import Background from 'components/atoms/Background'
import { AVAILABLE_BRANDS } from 'styles/theme'
import { getImageURL } from 'utils/image'
import { trimText } from 'utils/text'

import * as S from './styled'

const BaseLayout = ({ content: quote, ...rest }) => {
  const { ilustration, sportFigure, photo, name, position, quotationText } = quote
  const { color } = useTheme()

  return (
    <S.Container {...rest}>
      <Background illustration={ilustration} />
      <S.SportFigure>{sportFigure && <img src={getImageURL(sportFigure)} />}</S.SportFigure>
      <S.AuthorInfo>
        {photo && <S.Image src={getImageURL(photo)} />}
        <div className='text-content'>
          <p className='author'>{name}</p>
          <span className='position'>{position}</span>
        </div>
      </S.AuthorInfo>
      <S.Quote>
        {(color === AVAILABLE_BRANDS.CLOUD_LIGHT || color === AVAILABLE_BRANDS.CLOUD_DARK) && <QuotesCloudSvg />}
        <p className='quote'>{trimText(quotationText, 200)}</p>
      </S.Quote>
      <S.Footer />
    </S.Container>
  )
}

BaseLayout.defaultProps = {
  content: {},
}

BaseLayout.propTypes = {
  content: PropTypes.object,
}

export default BaseLayout
